import product from '@/components/product/index.vue'
import groupProduct from '@/components/group-product/index.vue'
import categoryFilter from './components/category-filter/index.vue'
import sortSelect from './components/sort-select/index.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import { directive as onClickaway } from 'vue-clickaway'
import { debounce, map } from "lodash";
import dynamicsHead from "@/mixins/dynamics-head";

export default {
  name: 'catalog',
  directives: {
    onClickaway: onClickaway,
  },
  mixins: [dynamicsHead],
  data() {
    return {
      loadingProducts: false,
      loadingFilters: false,
      products: [],
      filters: [],
      openFilter: false,
      storedCatalogType: null,
      paginator: {
        hasNextPage: false,
        page: 1,
        perPage: 3 * 4, // load 4 lines per 3 product
      },
    }
  },
  components: {
    groupProduct,
    product,
    categoryFilter,
    sortSelect,
  },
  watch: {
    async $route() {
      if (this.storedCatalogType !== this.catalogType) {
        this.products = []
        this.storedCatalogType = this.catalogType
      }
      if (!this.loadingProducts) {
        this.resetPage()
        await this.loadProducts()
        if (this.$route.query && this.$route.query.categories && this.$route.query.categories.includes("outlet")) {
          await this.fetchOutletInfo();
        }
        // if (this.$route.query && this.$route.query.sale_banners) {
        //   await this.fetchPromotionInfo(this.$route.query.sale_banners);
        // }
      }
    },
  },
  async created() {
    await Promise.all([this.loadFilters(), this.loadProducts(), this.fetchPage('catalog')])
    this.storedCatalogType = this.catalogType
    if (this.$route.query && this.$route.query.categories && this.$route.query.categories.includes("outlet")) {
      await this.fetchOutletInfo();
    }
    // if (this.$route.query && this.$route.query.sale_banners) {
    //   await this.fetchPromotionInfo(this.$route.query.sale_banners);
    // }
    this.setPageMetaInfo(this.page)
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      favourites: 'favorites/whichList',
      user: 'profile/user',
      isDistributor: 'profile/isDistributor',
      isProfessional: 'profile/isProfessional',
      outletPageInfo: "products/outletPageInfo",
      currentPromotion: "promotions/currentPromotion",
    }),
    isOutlet() {
      return this.$route.query && this.$route.query.categories && this.$route.query.categories.includes("outlet")
    },
    isPromotionsBanner() {
      return this.$route.query && this.$route.query.sale_banners
    },
    productsList() {
      if (!this.isAuthenticated || !this.favourites) {
        return this.products
      }

      const favourites = map(this.favourites, 'productId')
      const markAsSelected = (product) => {
        product.isFavorite = favourites.includes(product.id)
        return product
      }

      if (this.catalogType === 'table') {
        return map(this.products, markAsSelected)
      }

      return this.products.map((productGroup) => {
        map(productGroup.products, markAsSelected)

        return productGroup
      })
    },
    catalogType() {
      if (this.$route.query.catalog_type === 'groups') {
        return 'groups'
      }

      return 'table'
    },
  },
  methods: {
    ...mapActions({
      fetchProductsForCatalog: 'products/GET_PRODUCTS_FOR_CATALOG',
      fetchCatalogFilters: 'products/GET_CATALOG_FILTERS',
      fetchOutletInfo: "products/GET_OUTLET_INFO",
      fetchPromotionInfo: "promotions/FETCH_PROMOTION",
      fetchPage: "pages/GET_PAGE"
    }),
    ...mapMutations({}),
    openFilters() {
      this.openFilter = !this.openFilter
      if (this.openFilter) {
        document.getElementById('html').classList.add('hide')
      } else {
        document.getElementById('html').classList.remove('hide')
      }
    },
    openCategory(item) {
      // XOR
      return !!(item.isOpened ^ this.open)
    },
    changeSlideToggle() {
      this.open = !this.open
    },
    resetFilter() {
      this.$router
        .push({
          name: 'products',
          query: {
            catalog_type: this.$route.query.catalog_type,
          },
        })
        .catch(() => {})
    },
    away: function () {
      this.openFilter = !this.openFilter
    },
    resetPage() {
      this.paginator.page = 1
      this.paginator.hasNextPage = false
    },
    async loadFilters() {
      this.filters = await this.fetchCatalogFilters()
    },
    loadProducts: debounce(async function() {
      this.loadingProducts = true

      let urlQuery = cloneDeep(this.$route.query)

      if (this.paginator.page === 1) {
        this.products = []
      }

      /** @type {ICatalogFilter} */
      const catalogFilters = {
        catalog_type: urlQuery.catalog_type,
        sort_filter_type: urlQuery.sort_filter_type || 'bestsellers',
        brands: urlQuery.brands,
        series: urlQuery.series,
        categories: urlQuery.categories,
        sale_banners: urlQuery.sale_banners,
        page: this.paginator.page,
        perPage: this.paginator.perPage,
      }
      const catalogData = await this.fetchProductsForCatalog(catalogFilters)

      this.products.push(...catalogData.data)

      this.paginator.hasNextPage = !!catalogData.links.next

      this.loadingProducts = false

      const transformedProducts = this.productsList.map((item) => {
        return {
          item_id: item.productPrices.data[0].article,
          item_name: item.title,
          affiliation: 'Renew-Cosmetics',
          coupon: '',
          discount: 0.0,
          index: 0,
          item_brand: item.brand?.data?.title || 'Renew',
          item_category: item.brandSeries?.data?.title || '',
          item_category2: (() => {
            if (!this.isAuthenticated) return 'unauthorized'
            if (this.isProfessional) return 'professional'
            if (this.isDistributor) return 'distributor'
            return 'regular'
          })(),
          item_list_id: 'Cosmetics',
          item_list_name: 'Cosmetics',
          location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
          price: Number(item.productPrices.data[0].price).toFixed(2),
          quantity: 1,
        }
      })
      window.dataLayer.push({ ecommerce: null })
      window.dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          item_list_id: 'renew-cosmetics',
          item_list_name: 'Renew-Cosmetics',
          items: transformedProducts,
        },
      })
    }, 500),
    async paginateProducts() {
      this.paginator.page += 1

      await this.loadProducts()
    },
  },
}
